/**
 * Remove accented characters to prevent Radix UI Select crashes.
 * Accented characters in Select values/labels cause silent React crashes.
 */
const ACCENT_MAP = {
  'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
  'à': 'a', 'â': 'a', 'ä': 'a',
  'ù': 'u', 'û': 'u', 'ü': 'u',
  'ô': 'o', 'ö': 'o',
  'î': 'i', 'ï': 'i',
  'ç': 'c',
  'É': 'E', 'È': 'E', 'Ê': 'E', 'Ë': 'E',
  'À': 'A', 'Â': 'A', 'Ä': 'A',
  'Ù': 'U', 'Û': 'U', 'Ü': 'U',
  'Ô': 'O', 'Ö': 'O',
  'Î': 'I', 'Ï': 'I',
  'Ç': 'C',
};

export function sanitize(text) {
  if (!text) return '';
  let result = String(text);
  for (const [accented, plain] of Object.entries(ACCENT_MAP)) {
    result = result.replaceAll(accented, plain);
  }
  return result;
}

export default sanitize;
